import { render, staticRenderFns } from "./ribbon.html?vue&type=template&id=6c61b257&scoped=true&"
import script from "./ribbon.js?vue&type=script&lang=js&"
export * from "./ribbon.js?vue&type=script&lang=js&"
import style0 from "./ribbon.scss?vue&type=style&index=0&id=6c61b257&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61b257",
  null
  
)

export default component.exports